import { Card } from "@clipboard-health/ui-components";

interface TierCardWrapperProps {
  children: React.ReactNode;
  image: string;
  imageSize: number;
  background: string | undefined;
  transform?: string;
}

export function TierCardWrapper(props: TierCardWrapperProps) {
  const { children, image, imageSize, background, transform } = props;
  return (
    <Card
      sx={{
        padding: 6,
        minHeight: "fit-content",
        background,
        position: "relative",
        overflow: "hidden",
        "&::after": {
          content: '""',
          position: "absolute",
          bottom: -50,
          right: -50,
          width: imageSize,
          height: imageSize,
          background: `url(${image})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          transform,
          transformOrigin: "center",
          pointerEvents: "none",
        },
      }}
      variant="tertiary"
    >
      {children}
    </Card>
  );
}
